export const validDomains = {
    "https://fnti.net/,ON": "First Nations Technical Institute",
    "http://www.uwo.ca/,ON": "University of Western Ontario",
    "http://www.wlu.ca/,ON": "Wilfrid Laurier University",
    "https://osttc.com/,ON": "Ogwehoweh Skills and Trades Training Centre",
    "http://www.ocad.ca/,ON":
        "OCAD University (Ontario College of Art and Design)",
    "http://www.ocadu.ca/,ON":
        "OCAD University (Ontario College of Art and Design)",
    "https://algomau.ca/,ON": "Algoma University",
    "http://www.sl.on.ca/,ON": "St. Lawrence College",
    "http://www.yorku.ca/,ON": "York University",
    "https://uontario.ca/,ON": "Université de l'Ontario Français",
    "https://www.nosm.ca/,ON": "Northern Ontario School of Medicine University",
    "http://www.brocku.ca/,ON": "Brock University",
    "http://www.humber.ca/,ON": "Humber College",
    "http://www.humbermail.ca/,ON": "Humber Polytechnic",
    "http://www.trentu.ca/,ON": "Trent University",
    "https://www.oshki.ca/,ON":
        "Oshki-Pimache-O-Win: The Wenjack Education Institute",
    "http://www.queensu.ca/,ON": "Queen's University",
    "http://www.uhearst.ca/,ON": "Université de Hearst",
    "http://www.uottawa.ca/,ON": "University of Ottawa",
    "http://www.carleton.ca/,ON": "Carleton University",
    "http://www.mcmaster.ca/,ON": "McMaster University",
    "http://www.uoguelph.ca/,ON": "University of Guelph",
    "http://www.guelphhumber.ca/,ON": "University of Guelph-Humber",
    "http://www.utoronto.ca/,ON": "University of Toronto",
    "http://www.uwindsor.ca/,ON": "University of Windsor",
    "https://shingwauku.org/,ON": "Shingwauk Kinoomaage Gamig",
    "http://www.lakeheadu.ca/,ON": "Lakehead University",
    "http://www.uwaterloo.ca/,ON": "University of Waterloo",
    "https://ontariotechu.ca/,ON": "Ontario Tech University",
    "http://www.laurentian.ca/,ON": "Laurentian University",
    "http://www.nipissingu.ca/,ON": "Nipissing University",
    "https://collegeboreal.ca/,ON": "Collège Boréal",
    "https://durhamcollege.ca/,ON": "Durham College",
    "https://dcmail.ca/,ON": "Durham College",
    "https://iohahiio.ambe.ca/,ON":
        "Iohahi:io Akwesasne Education & Training Institute",
    "https://www.fanshawec.ca/,ON": "Fanshawe College",
    "https://www.fanshaweoneline.ca/,ON": "Fanshawe College",
    "https://www.torontomu.ca/,ON": "Toronto Metropolitan University",
    "https://www.ryerson.ca/,ON": "Toronto Metropolitan University (Formerly Ryerson University)",
    "https://flemingcollege.ca/,ON": "Fleming College",
    "http://www.georgianc.on.ca/,ON": "Georgian College",
    "https://cambriancollege.ca/,ON": "Cambrian College",
    "https://www.georgebrown.ca/,ON": "George Brown College",
    "http://www.conestogac.on.ca/,ON": "Conestoga College",
    "http://www.senecacollege.ca/,ON": "Seneca College",
    "https://aeipostsecondary.ca/,ON": "Anishinabek Educational Institute",
    "https://www.kenjgewinteg.ca/,ON": "Kenjgewin Teg",
    "https://www.saultcollege.ca/,ON": "Sault College",
    "https://www.7generations.org/,ON": "Seven Generations Education Institute",
    "https://www.collegelacite.ca/,ON": "La Cité Collégiale",
    "https://www.mohawkcollege.ca/,ON": "Mohawk College",
    "http://www.sheridancollege.ca/,ON": "Sheridan College",
    "https://www.lambtoncollege.ca/,ON": "Lambton College",
    "https://www.mylambton.ca/,ON": "Lambton College",
    "https://www.niagaracollege.ca/,ON": "Niagara College",
    "https://www.snpolytechnic.com/,ON": "Six Nations Polytechnic",
    "https://www.senecapolytechnic.ca/,ON": "Seneca Polytechnic",
    "https://www.myseneca.ca/,ON": "Seneca College",
    "https://www.stclaircollege.ca/,ON": "St. Clair College",
    "https://www.myscc.ca/,ON": "St. Clair College",
    "http://www.loyalistcollege.com/,ON": "Loyalist College",
    "https://www.canadorecollege.ca/,ON": "Canadore College",
    "https://www.northerncollege.ca/,ON": "Northern College",
    "http://www.algonquincollege.com/,ON": "Algonquin College",
    "https://www.algonquinlive.com/,ON": "Algonquin College",
    "http://www.centennialcollege.ca/,ON": "Centennial College",
    "https://www.confederationcollege.ca/,ON": "Confederation College",
    "https://www.mylaurier.ca/,ON": "Wilfrid Laurier University",
    "https://www.redeemer.ca/,ON": "Redeemer University",
};
